<div class="wiki-item" [id]="wikiItem()._id" (click)="onEditWikiItem()" cdkDrag>
  <div class="wiki-item__drag-handler-container">
    <mat-icon class="wiki-item__drag-handler" svgIcon="drag-handler" cdkDragHandle />
    <span class="wiki-item-title" [title]="wikiItem().title">{{ wikiItem().title }}</span>
  </div>

  <div class="wiki-item__info-container">
    <div class="wiki-item__info-date">edited {{ wikiItem().createdAt | date: 'MMMM d, y' }}</div>
    <button
      class="wiki-item__copy-link-button"
      type="button"
      mat-flat-button
      [matTooltip]="'Copy link'"
      (click)="onCopyWikiItemLink($event)"
      [cdkCopyToClipboard]="getWikiItemLink()"
    >
      <mat-icon svgIcon="chain" />
    </button>
  </div>

  <div class="wiki-item-drag-preview" *cdkDragPreview>
    {{ wikiItem().title }} - {{ wikiItem().createdAt | date: 'MMMM d, y' }}
  </div>
  <div class="wiki-item-drag-placeholder" *cdkDragPlaceholder></div>
</div>
